import axios from 'axios';
import getBaseUrl from '@/utils/getUrl';

const getStripeApiKey = async () => {
  const baseUrl = getBaseUrl();
  const apiUrl = `${baseUrl}/wp-json/gff/v1`;
  const url = `${apiUrl}/stripe-key`;
  return (await axios.get(url))?.data || [];
}

export default { getStripeApiKey };